import { ResultDataType } from '../../shared';

const format = (value: number | string, dataType: ResultDataType): string => {
    switch (dataType) {
        case ResultDataType.THOUSAND_DOLLAR: {
            return `${value}k`;
        }

        case ResultDataType.MILLION_DOLLAR: {
            return `${value}m`;
        }

        case ResultDataType.BILLION_DOLLAR: {
            return `${value}b`;
        }

        case ResultDataType.PERCENT: {
            return `${value}%`;
        }

        default: {
            return `${value}`;
        }
    }
};

export type ResultFilter = (value: number | string, dataType: ResultDataType) => string;

const resultFilter = (): ResultFilter => format;

export { resultFilter };
